// extracted by mini-css-extract-plugin
export default {"imageContainer":"A0-z","summaryPar":"B0-z","ratingCategories":"C0-z","reviewerInfo":"D0-z","reviewTypes":"E0-z","expanded":"F0-z"};